<template>
  <section id="home" class="show">
    <!-- slider -->
    <!-- <div class="register-alert alert alert-success alert-dismissible" v-if="showToast" style="text-align:center">
      <button type="button" class="close" data-dismiss="alert">&times;</button>
      <strong>Welcome!</strong>
      {{loggedInUser.name}} to fintransformer.
    </div> -->

    <div class="slider-section">
      <div
        id="carouselExampleIndicators"
        class="carousel slide"
        data-ride="carousel"
      >
        <ol class="carousel-indicators">
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            class="active"
          ></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="over-lay"></div>
            <img
              class="d-block w-100"
              src="../../static/static-css/img/slider/slider-1.jpg"
              alt="First slide"
            />
            <div class="carousel-caption">
              <h5 class="upper-title">FINTRANSFORMER &trade;</h5>
              <h1 class="slider-title">
                International Companies Dealing with Russian Customers
              </h1>
              <!-- <p
                class="slider-text"
              >International Companies Dealing with Russian Customers.</p>-->
              <router-link
                :to="`/transformation-input/FinancialStatements`"
                class="financial-link"
              >
                Go to Financial Statements Translation
                <i class="arrow_right"></i>
              </router-link>
              <!-- <a href="#" class="financial-link">
                Go to Financial Statements Translation
                <i class="arrow_right"></i>
              </a>-->
            </div>
          </div>
          <div class="carousel-item">
            <div class="over-lay"></div>
            <img
              class="d-block w-100"
              src="../../static/static-css/img/slider/slider-2.jpg"
              alt="Second slide"
            />
            <div class="carousel-caption">
              <h5 class="upper-title">FINTRANSFORMER &trade;</h5>
              <h1 class="slider-title">
                Russian Companies Dealing with Foreign Vendors
              </h1>
              <!-- <p
                class="slider-text"
              >Russian Companies Dealing with Foreign Vendors.</p>-->
              <router-link
                :to="`/transformation-input/FinancialStatements`"
                class="financial-link"
              >
                Go to Financial Statements Translation
                <i class="arrow_right"></i>
              </router-link>
            </div>
          </div>
          <div class="carousel-item">
            <div class="over-lay"></div>
            <img
              class="d-block w-100"
              src="../../static/static-css/img/slider/slider-3.jpg"
              alt="Third slide"
            />
            <div class="carousel-caption">
              <h5 class="upper-title">FINTRANSFORMER &trade;</h5>
              <h1 class="slider-title">
                Financial Institutions Dealing with Russian Obligors
              </h1>
              <!-- <p
                class="slider-text"
              >Financial Institutions Dealing with Russian Obligors.</p>-->
              <router-link
                :to="`/transformation-input/FinancialStatements`"
                class="financial-link"
              >
                Go to Financial Statements Translation
                <i class="arrow_right"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end slider -->
    <div class="feature-section" id="products">
      <div class="container">
        <div class="section-title">
          <!-- <div class="sub-title"><span>WE ARE FINTRANSFORMER</span></div> -->
          <div class="title">
            <h2>Translate Standard Russian Financial Statements</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <a class data-toggle="modal" data-target="#feature1">
              <div
                class="fz-post feature-post"
                style="
                  height: 100%;
                  background-image: url('../../static/static-css/img/feature-image/gold-bars.jpg');
                "
              >
                <!-- feature-image -->
                <div class="fz-post-title feature text-center">
                  <h2>Own Financial Statements</h2>
                </div>
                <!-- feature-title -->
                <div class="fz-post-content fz-post-content-sec feature">
                  <h4>Own Financial Statements</h4>
                  <p class="hover-text">
                    Are you a Russian corporate entity which buys, or would like
                    to buy, goods or services on credit?
                  </p>
                  <p class="hover-text">
                    Do your foreign vendors ask for your financial statements to
                    decide if they will extend credit to you?
                  </p>
                  <p class="hover-text">
                    This tool can translate your standard Russian Federation
                    financials into English and present the numbers in a format
                    which your foreign vendors will find more familiar compared
                    to the standard Russian Federation format.
                  </p>
                  <p class="hover-text">
                    Your foreign vendors will appreciate getting your company's
                    financials in English and in a familiar format, as it will
                    facilitate their assessment of your company's
                    creditworthiness.
                  </p>
                  <div class="fz-button">
                    <!-- <router-link :to="`/transformation-input/FinancialStatements`" class="fz-btn btn">Financial Statements Translation</router-link> -->
                    <!-- <a href="/transformation-input/FinancialStatements" class="fz-btn btn">Financial Statements Translation</a> -->
                    <button
                      @click="fslink($event, true)"
                      class="fz-btn btn feature-btn"
                    >
                      Financial Statements Translation
                    </button>
                  </div>
                </div>
                <!-- feature-content -->
              </div>
            </a>
          </div>
          <!-- col-md-4 -->
          <div class="col-12 mb-3">
            <a class data-toggle="modal" data-target="#feature2">
              <div
                class="fz-post feature-post"
                style="
                  height: 100%;
                  background-image: url('../../static/static-css/img/feature-image/coins-in-glass.jpg');
                "
              >
                <!-- feature-image -->
                <div class="fz-post-title feature text-center">
                  <h2>Customer’s Financial Statements</h2>
                </div>
                <!-- feature-title -->
                <div class="fz-post-content fz-post-content-sec feature">
                  <h4>Customer’s Financial Statements</h4>
                  <p class="hover-text">
                    Do you sell, or would like to sell, goods or services on
                    credit to corporate customers in the Russian Federation?
                  </p>
                  <p class="hover-text">
                    Do you rely on financial statements of your customers in the
                    Russian Federation to decide if you should extend credit to
                    them?
                  </p>
                  <p class="hover-text">
                    Our simple and easy to use financial statements translation
                    tool can convert standard Russian financial statements into
                    English and present the numbers in a format with wider
                    international acceptance compared to standard Russian
                    Federation financial statements.
                  </p>
                  <p class="hover-text">
                    That can assist you in evaluating your customers’
                    creditworthiness, and help you decide if you could sell to
                    them on credit.
                  </p>
                  <div class="fz-button">
                    <!-- <router-link :to="`/transformation-input/FinancialStatements`" class="fz-btn btn">Financial Statements Translation</router-link> -->
                    <!-- <a href="/transformation-input/FinancialStatements" class="fz-btn btn">Financial Statements Translation</a> -->
                    <button
                      @click="fslink($event, true)"
                      class="fz-btn btn feature-btn"
                    >
                      Financial Statements Translation
                    </button>
                  </div>
                </div>
                <!-- feature-content -->
              </div>
            </a>
          </div>
          <!-- col-md-4  colmd4 -->
          <div class="col-12 mb-3">
            <a class data-toggle="modal" data-target="#feature3">
              <div
                class="fz-post feature-post"
                style="
                  height: 100%;
                  background-image: url('../../static/static-css/img/feature-image/coins-on-dollar.jpg');
                "
              >
                <!-- feature-image -->
                <div class="fz-post-title feature text-center">
                  <h2>Obligor’s Financial Statements</h2>
                </div>
                <!-- feature-title -->
                <div class="fz-post-content fz-post-content-sec feature">
                  <h4>Obligor’s Financial Statements</h4>
                  <p class="hover-text">
                    Are you a Bank, a Credit Insurance Company or a Factoring
                    Company?
                  </p>
                  <p class="hover-text">
                    Do you have customers in the Russian Federation? Do your
                    customers have customers in the Russian Federation?
                  </p>
                  <p class="hover-text">
                    Do you often analyze financial statements of corporate
                    entities in the Russian Federation to make decisions?
                  </p>
                  <p class="hover-text">
                    Our simple and easy to use financial statements translation
                    tool can convert standard Russian financial statements into
                    English and present the numbers in an internationally
                    recognized format.
                  </p>
                  <div class="fz-button">
                    <!-- <router-link :to="`/transformation-input/FinancialStatements`" class="fz-btn btn">Financial Statements Translation</router-link> -->
                    <!-- <a href="/transformation-input/FinancialStatements" class="fz-btn btn">Financial Statements Translation</a> -->
                    <button
                      @click="fslink($event, true)"
                      class="fz-btn btn feature-btn"
                    >
                      Financial Statements Translation
                    </button>

                    <!-- <a class="fz-btn btn" href="#">Financial Statements Translation</a> -->
                  </div>
                </div>
                <!-- feature-content -->
              </div>
            </a>
          </div>
          <!-- col-md-4 -->
        </div>
      </div>
    </div>

    <section id="pricing" class="pricing py-5">
      <div class="container-fluid">
        <div class="section-title">
          <div class="title">
            <h2>Pricing</h2>
          </div>
          <div class="sub-title">
            <span>Financial Statements Translation</span>
          </div>
        </div>
        <div class="row plan justify-content-center">
          <!-- Free Tier -->
          <div class="col-lg-2 col-md-6 mb-5">
            <div class="box mb-lg-0">
              <div class="plan-head">
                <h5 class="card-title text-center">New Customer</h5>
              </div>
              <hr />
              <div class="plan-body">
                <div class="price">
                  <h4 class="card-price text-center">
                    <small>Free</small>
                    <!-- <span class="period">/month</span> -->
                  </h4>
                </div>
                <ul class="fa-ul">
                  <li>
                    <span class="fa-li">
                      <i class="fas fa-check"></i>
                    </span>
                    <strong>1 User</strong>
                  </li>
                  <li>
                    <span class="fa-li"> <i class="fas fa-check"></i> </span>10
                    translations per year
                  </li>
                  <li>
                    <span class="fa-li"> <i class="fas fa-check"></i> </span
                    >Unused translations do not get carried over to the
                    following year
                  </li>
                  <li>
                    <span class="fa-li"> <i class="fas fa-check"></i> </span
                    >Credit card or payment information not required
                  </li>
                  <li class="text-success">
                    Offer valid until 30 June {{ new Date().getFullYear() }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Dynamic Tier -->
          <div
            class="col-lg-2 col-md-6 mb-5"
            v-for="(plans, key) in paymentsplan"
            :key="key"
          >
            <div class="box mb-lg-0">
              <div class="plan-head">
                <h5 class="card-title text-center">{{ plans.name }}</h5>
              </div>
              <hr />
              <div class="plan-body">
                <div class="price">
                  <h4 class="card-price text-center">
                    <small>USD</small>
                    {{ plans.cost }}
                    <span class="period">/{{ plans.slug }}</span>
                  </h4>
                </div>
                <ul class="fa-ul" v-html="plans.description"></ul>
              </div>
              <div class="plan-footer">
                <span class="recomendation" v-if="plans.recommendation">{{
                  plans.recommendation
                }}</span>
                <button
                  type="button"
                  class="btn btn-block text-uppercase pointer"
                  :disabled="!plans.isActive"
                  data-toggle="tooltip"
                  data-placement="top"
                  :title="plans.isActive ? '' : 'Coming soon'"
                  :class="
                    plans.isActive === 0 ? 'disable-button' : 'btn-primary'
                  "
                  @click="plans.isActive ? checkout(plans) : null"
                >
                  Get Plan
                </button>
              </div>
            </div>
          </div>
          <!-- Custom Tier -->
          <div class="col-lg-2 col-md-6 mb-5">
            <div class="box mb-lg-0">
              <div class="plan-head">
                <h5 class="card-title text-center">Custom</h5>
              </div>
              <hr />
              <div class="plan-body">
                <div class="price">
                  <h4 class="card-price text-center">
                    <small>USD</small> TBD
                    <!-- 15
                    <span class="period">per month</span> -->
                  </h4>
                </div>
                <ul class="fa-ul">
                  <li>
                    <span class="fa-li"> <i class="fas fa-check"></i> </span
                    >Flexible plan Ideal for high volume use
                  </li>
                  <li>
                    <span class="fa-li"> <i class="fas fa-check"></i> </span
                    >Negotiated pricing based on number of users and number of
                    monthly assessments
                  </li>
                  <li>
                    <span class="fa-li"> <i class="fas fa-check"></i> </span>Or
                  </li>
                  <li>
                    <span class="fa-li"> <i class="fas fa-check"></i> </span>Buy
                    a copy of our translation software
                  </li>
                  <!-- <li>
                    <strong>Please <a href="#testimonial">Contact Us</a> to discuss</strong>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- padding-bottom70 -->
    <div id="testimonial" class="contact-section testimonial padding-top70">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="call-back">
              <div class="title">
                <h2>Contact Us</h2>
              </div>
              <form>
                <fieldset :disabled="contactFormLoading">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-warning text-left"
                        v-if="formError"
                        v-html="formError"
                      ></div>
                    </div>
                  </div>
                  <div class="discussion-info">
                    <div class="row mt-5">
                      <div class="col-6">
                        <input
                          v-model="contactForm.full_name"
                          type="text"
                          required
                          class="form-control"
                          maxlength="15"
                          placeholder="Full Name *"
                        />
                      </div>
                      <div class="col-6">
                        <input
                          v-model="contactForm.email"
                          type="email"
                          required
                          class="form-control"
                          placeholder="Email *"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- discussion-info -->
                  <div class="discussion-type">
                    <select
                      class="white-placeholder"
                      v-model="contactForm.reason"
                      id="inputState"
                      title="Please Select a Reason from the list."
                      required
                    >
                      <option value disabled selected>Select Reason *</option>
                      <option value="Partnering Opportunity">
                        Partnering Opportunity
                      </option>
                      <option value="Provide Feedback">Provide Feedback</option>
                      <option value="Report an Error">Report an Error</option>
                      <option value="Request a Feature">
                        Request a Feature
                      </option>
                      <option value="Make a Suggestion">
                        Make a Suggestion
                      </option>
                      <option value="General Question">General Question</option>
                      <option value="Subscription or Payment">
                        Subscription or Payment
                      </option>
                      <option value="User Profile or Access">
                        User Profile or Access
                      </option>
                      <option value="Other">Other</option>
                    </select>
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <textarea
                          class="form-control"
                          style="width: 100%; height: 150px"
                          v-model="contactForm.message"
                          maxlength="1000"
                          placeholder="Your Message *"
                          required
                          title="Your Message has much importance to us."
                        >
Message</textarea
                        >
                      </div>
                    </div>
                    <div class="submit">
                      <button
                        type="submit"
                        :disabled="contactFormLoading"
                        @click.prevent="sendMail"
                      >
                        submit
                        <span>
                          <i class="arrow_right"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </fieldset>
                <!-- discussion-type -->
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="contact-loader-pane" id="loading" v-if="contactFormLoading">
        <div class="contact-loader"></div>
      </div>-->
    </div>
    <!-- testimonial section end -->

    <!-- Modals -->

    <div
      class="modal fade feature-modal"
      id="feature1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="feature1Title"
      aria-hidden="true"
    >
      <!-- Add .modal-dialog-centered to .modal-dialog to vertically center the modal -->
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Own Financial Statements
            </h5>
            <button
              type="button"
              ref="exchangeModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="hover-text">
              Are you a Russian corporate entity which buys, or would like to
              buy, goods or services on credit?
            </p>
            <p class="hover-text">
              Do your foreign vendors ask for your financial statements to
              decide if they will extend credit to you?
            </p>
            <p class="hover-text">
              This tool can translate your standard Russian Federation
              financials into English and present the numbers in a format which
              your foreign vendors will find more familiar compared to the
              standard Russian Federation format.
            </p>
            <p class="hover-text">
              Your foreign vendors will appreciate getting your company's
              financials in English and in a familiar format, as it will
              facilitate their assessment of your company's creditworthiness.
            </p>
          </div>
          <div class="modal-footer">
            <!-- <div class="fz-button text-center"> -->
            <!-- <router-link :to="`/transformation-input/FinancialStatements`" class="fz-btn btn feature-btn">Financial Statements Translation</router-link> -->
            <button
              @click="fslink($event, true)"
              class="fz-btn btn feature-btn"
            >
              Financial Statements Translation
            </button>
            <!-- <a class="fz-btn btn feature-btn" href="#">Financial Statements Translation</a> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade feature-modal"
      id="feature2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="feature2Title"
      aria-hidden="true"
    >
      <!-- Add .modal-dialog-centered to .modal-dialog to vertically center the modal -->
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalLongTitle">
              Customer’s Financial Statements
            </h5>
            <button
              type="button"
              ref="exchangeModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="hover-text">
              Do you sell, or would like to sell, goods or services on credit to
              corporate customers in the Russian Federation?
            </p>
            <p class="hover-text">
              Do you rely on financial statements of your customers in the
              Russian Federation to decide if you should extend credit to them?
            </p>
            <p class="hover-text">
              Our simple and easy to use financial statements translation tool
              can convert standard Russian financial statements into English and
              present the numbers in a format with wider international
              acceptance compared to standard Russian Federation financial
              statements.
            </p>
            <p class="hover-text">
              That can assist you in evaluating your customers’
              creditworthiness, and help you decide if you could sell to them on
              credit.
            </p>
          </div>
          <div class="modal-footer">
            <!-- <div class="fz-button text-center"> -->
            <!-- <router-link :to="`/transformation-input/FinancialStatements`" class="fz-btn btn feature-btn">Financial Statements Translation</router-link> -->
            <button
              @click="fslink($event, true)"
              class="fz-btn btn feature-btn"
            >
              Financial Statements Translation
            </button>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade feature-modal"
      id="feature3"
      tabindex="-1"
      role="dialog"
      aria-labelledby="feature2Title"
      aria-hidden="true"
    >
      <!-- Add .modal-dialog-centered to .modal-dialog to vertically center the modal -->
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalLongTitle">
              Obligor’s Financial Statements
            </h5>
            <button
              type="button"
              ref="exchangeModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="hover-text">
              Are you a Bank, a Credit Insurance Company or a Factoring Company?
            </p>
            <p class="hover-text">
              Do you have customers in the Russian Federation? Do your customers
              have customers in the Russian Federation?
            </p>
            <p class="hover-text">
              Do you often analyze financial statements of corporate entities in
              the Russian Federation to make decisions?
            </p>
            <p class="hover-text">
              Our simple and easy to use financial statements translation tool
              can convert standard Russian financial statements into English and
              present the numbers in an internationally recognized format.
            </p>
          </div>
          <div class="modal-footer">
            <!-- <div class="fz-button text-center"> -->
            <!-- <router-link :to="`/transformation-input/FinancialStatements`" class="fz-btn btn feature-btn">Financial Statements Translation</router-link> -->
            <button
              @click="fslink($event, true)"
              class="fz-btn btn feature-btn"
            >
              Financial Statements Translation
            </button>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      formError: "",
      apiresponse: "",
      contactForm: {
        full_name: "",
        email: "",
        message: "",
        reason: "",
      },
      contactFormLoading: false,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.user.isLoggedIn,
      // showToast: (state) => state.user.showToast,
      loggedInUser: (state) => state.user.loggedInUser,
      paymentsplan: (state) => state.payments.financialStatments_plans,
    }),
  },
  created() {
    this.$store.commit("ISLOADING", false);
  },
  async mounted() {
    // setTimeout(() => {
    //   this.$store.commit('DISPLAYTOAST', false)
    // }, 5000)
    await this.$store.dispatch("FINANCIAL_STATMENT_TRANSLATION_PLANS");
  },
  methods: {
    login: function () {
      if (this.isLoggedIn) {
        this.$router.push({
          name: "TransformationInput",
          params: { type: "FinancialStatements" },
        });
      } else {
        this.$router.push({ path: "/login" });
      }
    },
    checkForm: function () {
      this.formError = "";
      this.errors = "";
      if (!this.contactForm.full_name.trim()) {
        this.formError += "Full Name required.<br>";
      }
      if (!this.contactForm.reason.trim()) {
        this.formError += "Select reason.<br>";
      }
      if (!this.contactForm.message.trim()) {
        this.formError += "Message should not be empty.<br>";
      }
      if (!this.contactForm.email.trim()) {
        this.formError += "Email required.<br>";
      } else if (!this.validEmail(this.contactForm.email.trim())) {
        this.formError += "Valid email required.<br>";
      }
      if (this.formError === "") return true;
      else return false;
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    clearInputs: function () {
      this.contactForm.full_name = "";
      this.contactForm.reason = "";
      this.contactForm.message = "";
      this.contactForm.email = "";
    },
    async sendMail() {
      if (this.checkForm()) {
        this.contactFormLoading = true;
        let response = await this.$store.dispatch(
          "SUBMIT_FORM",
          this.contactForm
        );
        // response = response.data
        // console.log(response.data.message)
        this.contactFormLoading = false;
        this.clearInputs();
        if (response.status === 200 || response.status === 201) {
          this.formError = "";
          this.$swal.fire(
            "Good job!",
            "We have received your message. Thank you!",
            "success"
          );
        } else {
          this.formError = "";
          this.contactFormLoading = false;
          this.$swal.fire("Error!", "Something Went Wrong", "warning");
        }
      }
    },
    fslink(e, fromModel) {
      console.log(e);
      e.stopPropagation();
      if (fromModel) {
        window.location = "/transformation-input/FinancialStatements";
      } else {
        this.$router.push({
          path: "/transformation-input/FinancialStatements",
        });
      }
    },
  },
};
</script>

<style lang="scss">
// @import "../../static/static-css/bootstrap.min.css";
// @import "../../static/static-css/elegant-font.css";
// @import "../../static/static-css/video.min.css";
// @import "../../static/static-css/animate.css";
// @import "../../static/rev-slider/css/settings.css";
// @import "../../static/rev-slider/css/layers.css";
// @import "../../static/rev-slider/css/navigation.css";
// @import "../../static/static-css/style.css";
// @import "../../static/static-css/responsive.css";
body {
  padding: 0px !important;
}
.register-alert {
  margin-bottom: 0px !important;
}
.Cookie__button {
  background: #118bf0 !important;
}
.disable-button {
  background: #dadada;
  color: #000;
  border-color: #dadada;
  width: 100%;
}
.disable-button :hover {
  background: #dadada !important;
  color: #000 !important;
  border-color: #dadada !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue